(function () {
  'use strict';

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* ============================================================
     Section refresh (used after Move/Add changes that bypass Dawn cart.js).
     Delegates to directRefresh() — this drawer omits Dawn's `.drawer__inner`
     hook, so Dawn's renderContents() throws; direct-inject avoids it.
     ============================================================ */
  function refreshDrawer() {
    if (!getDrawer()) return Promise.resolve();
    return directRefresh();
  }

  function refreshHeaderBubble() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var vc = c.item_count;
        /* Live header badge (velvety-header.liquid): the count span is only
           rendered when count > 0, so create/remove it as needed. */
        var cartLink = document.querySelector('#cart-icon-bubble');
        if (cartLink) {
          var span = cartLink.querySelector('.velvety-icons__count');
          if (vc > 0) {
            if (!span) {
              span = document.createElement('span');
              span.className = 'velvety-icons__count';
              cartLink.appendChild(span);
            }
            span.textContent = String(vc);
          } else if (span) {
            span.remove();
          }
        }
        /* Dawn fallbacks (no-op on the custom header). */
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = String(vc);
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = String(vc);
        });
      })
      .catch(function () { /* noop */ });
  }

  /* ============================================================
     Toast
     ============================================================ */
  var toastTimer = null;
  function showToast(msg) {
    var drawer = getDrawer();
    if (!drawer) return;
    var toast = drawer.querySelector('[data-velvety-cart-drawer-toast]');
    if (!toast) return;
    toast.textContent = msg;
    toast.removeAttribute('hidden');
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.setAttribute('hidden', 'hidden'); }, 250);
    }, 2200);
  }

  /* ============================================================
     Move to Wishlist (per row)
     ============================================================ */
  function bindMoveToWishlist(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-velvety-cart-drawer-move]').forEach(function (btn) {
      if (btn.__velvetyBound) return;
      btn.__velvetyBound = true;
      btn.addEventListener('click', function () {
        if (!window.VelvetyWishlist || typeof window.VelvetyWishlist.add !== 'function') {
          showToast('Wishlist unavailable');
          return;
        }
        var row = btn.closest('[data-velvety-cart-drawer-row]');
        var key = row && row.getAttribute('data-cart-key');
        if (!key) return;

        var options = (btn.getAttribute('data-option-values') || '').split('|').filter(Boolean);
        var optionNames = (btn.getAttribute('data-option-names') || '').split('|').filter(Boolean);
        window.VelvetyWishlist.add({
          handle: btn.getAttribute('data-product-handle'),
          title: btn.getAttribute('data-product-title'),
          url: btn.getAttribute('data-product-url'),
          image: btn.getAttribute('data-product-image'),
          price: btn.getAttribute('data-variant-price'),
          variant_id: btn.getAttribute('data-variant-id'),
          variant_title: btn.getAttribute('data-variant-title'),
          options: options,
          option_names: optionNames
        });
        row.classList.add('is-removing');
        /* Remove from cart by setting quantity to 0. Use the section's drawer section id
           so Dawn's section refresh fires and the inner items list updates. */
        var sectionId = (getDrawer() && getDrawer().id) || 'cart-drawer';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0, sections: sectionId, sections_url: window.location.pathname })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var drawer = getDrawer();
            if (drawer && typeof data.item_count === 'number') {
              drawer.classList.toggle('is-empty', data.item_count === 0);
            }
            if (data && data.sections && data.sections[sectionId]) {
              injectDrawerSection(data.sections[sectionId]);
            }
          })
          .then(function () {
            refreshHeaderBubble();
            showToast('Moved to wishlist');
          })
          .catch(function () { showToast('Could not move'); });
      });
    });
  }

  /* ============================================================
     Per-row Remove link (Dawn cart.js owns qty 0 path but our link
     posts the same change so any non-Dawn flow stays consistent)
     ============================================================ */
  function bindRemove(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-velvety-cart-drawer-remove]').forEach(function (btn) {
      if (btn.__velvetyBound) return;
      btn.__velvetyBound = true;
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-velvety-cart-drawer-row]');
        var qty = row && row.querySelector('input[name^="updates"]');
        if (qty) {
          qty.value = '0';
          /* Trigger change so Dawn's quantity-input handler picks it up.
             Dawn handles the AJAX + section refresh. */
          qty.dispatchEvent(new Event('change', { bubbles: true }));
          row.classList.add('is-removing');
        }
      });
    });
  }

  /* ============================================================
     Recommendation add (mini-PDP)
     ============================================================ */
  function bindRecAdd(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-velvety-cart-drawer-rec-add]').forEach(function (btn) {
      if (btn.__velvetyBound) return;
      btn.__velvetyBound = true;
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading')) return;
        var rec = btn.closest('.velvety-cart-drawer__rec');
        /* Prefer the new <select> dropdown; fall back to the legacy pill
           markup if any rec snippet still renders pills. */
        var sizeSelect = rec && rec.querySelector('[data-velvety-cart-drawer-rec-size-select]');
        var activePill = rec && rec.querySelector('[data-velvety-cart-drawer-rec-size-pill].is-active');
        var pickedSize = sizeSelect ? sizeSelect.value : (activePill ? activePill.getAttribute('data-size') : null);
        var defaultId = btn.getAttribute('data-variant-id');
        var variantId = defaultId;

        if (pickedSize) {
          /* Resolve variant id by matching the size selection within the embedded variants JSON. */
          var script = rec.querySelector('.velvety-cart-drawer__rec-variants');
          if (script) {
            try {
              var variants = JSON.parse(script.textContent);
              var sizePos = parseInt(btn.getAttribute('data-option-size-pos'), 10);
              if (sizePos > 0) {
                var match = variants.find(function (v) {
                  return v.available && v.options[sizePos - 1] === pickedSize;
                });
                if (match) variantId = match.id;
              }
            } catch (e) { /* fall through to default */ }
          }
        }

        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
          .then(function () {
            return refreshDrawer().then(refreshHeaderBubble);
          })
          .then(function () { showToast('Added to bag'); })
          .catch(function () { showToast('Could not add'); })
          .then(function () {
            setTimeout(function () { btn.classList.remove('is-loading'); }, 800);
          });
      });
    });
  }

  /* ============================================================
     Recommendations carousel nav
     ============================================================ */
  function bindRecsCarousel(scope) {
    scope = scope || document;
    var recs = scope.querySelector('[data-velvety-cart-drawer-recs]');
    if (!recs || recs.__velvetyBound) return;
    recs.__velvetyBound = true;
    var strip = recs.querySelector('[data-velvety-cart-drawer-recs-strip]');
    var prev = recs.querySelector('[data-velvety-cart-drawer-recs-prev]');
    var next = recs.querySelector('[data-velvety-cart-drawer-recs-next]');
    if (!strip) return;
    function scrollBy(dir) {
      var card = strip.querySelector('.velvety-cart-drawer__rec');
      var step = card ? card.offsetWidth + 12 : 192;
      strip.scrollBy({ left: dir * step * 2, behavior: 'auto' });
    }
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  }

  /* ============================================================
     Init + rebind after drawer re-renders
     ============================================================ */
  function bindRecSizePills(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-velvety-cart-drawer-rec-sizes]').forEach(function (group) {
      if (group.__velvetyBound) return;
      group.__velvetyBound = true;
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-velvety-cart-drawer-rec-size-pill]');
        if (!pill || !group.contains(pill)) return;
        group.querySelectorAll('[data-velvety-cart-drawer-rec-size-pill]').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');
      });
    });
  }

  /* ============================================================
     Quantity stepper. Dawn's <quantity-input> updates the visible input
     value on +/- click, but Dawn's CartDrawerItems change flow (cart.js)
     can't persist it here: this drawer's custom markup omits the Dawn
     hooks cart.js needs (no `step` attr → validateQuantity throws a false
     step error before posting; no `.drawer__inner` → the re-render throws).
     So we intercept the change in the capture phase to stop Dawn's broken
     handler, post the change ourselves, and inject the refreshed drawer
     section directly (mirrors the PDP add-to-bag refresh path).
     ============================================================ */
  function injectDrawerSection(html) {
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
    var live = document.querySelector('#CartDrawer');
    if (fresh && live) {
      live.innerHTML = fresh.innerHTML;
      /* Dawn binds the overlay-close click on the overlay element itself, so
         replacing the inner HTML drops it. Re-wire it to the drawer's close(). */
      var drawer = getDrawer();
      var overlay = live.querySelector('#CartDrawer-Overlay');
      if (drawer && overlay && typeof drawer.close === 'function') {
        overlay.addEventListener('click', function () { drawer.close(); });
      }
      bindAll();
    }
  }

  /* Re-fetch + inject the drawer section directly (avoids Dawn's
     renderContents, which dereferences a `.drawer__inner` this drawer
     doesn't have). Used to reflect a server change we made ourselves. */
  function directRefresh() {
    var sectionId = (getDrawer() && getDrawer().id) || 'cart-drawer';
    return fetch('/?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data[sectionId]) injectDrawerSection(data[sectionId]); });
  }

  function postLineQuantity(key, quantity) {
    var sectionId = (getDrawer() && getDrawer().id) || 'cart-drawer';
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId, sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var drawer = getDrawer();
        if (drawer && typeof data.item_count === 'number') {
          drawer.classList.toggle('is-empty', data.item_count === 0);
        }
        if (data && data.sections && data.sections[sectionId]) injectDrawerSection(data.sections[sectionId]);
      })
      .then(function () { return refreshHeaderBubble(); })
      .catch(function () { showToast('Could not update quantity'); });
  }

  function bindQuantityStepper(drawer) {
    if (!drawer || drawer.__velvetyQtyBound) return;
    drawer.__velvetyQtyBound = true;
    drawer.addEventListener('change', function (e) {
      var input = e.target && e.target.closest && e.target.closest('input[name^="updates"]');
      if (!input) return;
      e.stopImmediatePropagation();
      var row = input.closest('[data-velvety-cart-drawer-row]');
      var key = row && row.getAttribute('data-cart-key');
      if (!key) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      postLineQuantity(key, qty);
    }, true);
  }

  function bindAll() {
    var drawer = getDrawer();
    if (!drawer) return;
    bindQuantityStepper(drawer);
    bindMoveToWishlist(drawer);
    bindRemove(drawer);
    bindRecAdd(drawer);
    bindRecSizePills(drawer);
    bindRecsCarousel(drawer);
  }

  function watchDrawerForChanges() {
    var drawer = getDrawer();
    if (!drawer) return;
    /* Dawn's <cart-drawer> swaps innerHTML on section refresh — rebind every
       time a likely change happens. MutationObserver on the items wrap. */
    var items = drawer.querySelector('[data-velvety-cart-drawer-items]');
    if (!items) return;
    var observer = new MutationObserver(function () { bindAll(); });
    observer.observe(items.parentNode, { childList: true, subtree: true });
  }

  function init() {
    bindAll();
    watchDrawerForChanges();
  }

  /* Public surface for other Velvety scripts (notably velvety-card-product.js
     add-to-cart, which can't call Dawn's renderContents — it dereferences a
     `.drawer__inner` this drawer omits and throws, sending the shopper to
     the PDP via the catch fallback). Lets the card add path inject the new
     drawer markup directly and open the drawer without touching Dawn. */
  window.VelvetyCartDrawer = {
    inject: function (html) { injectDrawerSection(html); },
    refresh: function () { return directRefresh(); },
    refreshHeaderBubble: function () { return refreshHeaderBubble(); },
    open: function () {
      var drawer = getDrawer();
      if (drawer && typeof drawer.open === 'function') drawer.open();
    },
    bindAll: function () { bindAll(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
